import React, { useCallback, useEffect, useMemo, useState } from "react";
import "../../styles/layout/header.scss";
import { logout } from "../../redux/action/auth_action";
import { useDispatch, useSelector } from "react-redux";
import Modal from "components/Common/Modal";
import SettingZoneDropDown from "components/Common/Dropdowns/SettingZoneDropdown";
import ResetPassword from "components/Common/ResetPassword/resetPassword";
import UploadImages from "./UploadImages";
import {
  DEFAULT_TOTAL_RECORDS,
  DROPDOWN_STALE_TIME,
  MODALS,
  STALE_TIME,
} from "utils/constants";
import usePagination from "hooks/usePagination";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getEmployeesNotification,
  updateEmployeesNotification,
} from "services/firebase";
import Table from "components/Common/Table/index";
import { NOTIFICATION_COLUMNS_DATA } from "./Notification/Config";
import { fetchZonesDD } from "services/dropdown";
import { useMutation } from "@tanstack/react-query";
import { useAlert } from "context/alert";
import { createEmployeeMarkLogOut } from "services/attendance";
import { stripHtml } from "pages/TermsCondition/config";
import ProfilePicture from "./ProfilePicture";
import { getEmployeeProfilePicture } from "services/profilePicture";
import DocumentsDownload from "./DocumentsDownload";
import UploadDocument from "components/Common/KYC/UploadDocument";
import companyLocalStorageId from "utils/companyID";
import { useNavigate } from "react-router-dom";
import DynamicZoneLogo, {
  DEFAULT_APP_LOGO_SRC,
} from "components/Common/DynamicZoneLogo";
import ZoneLogoUpload from "./ZoneLogoUpload";
import { FaMoon, FaSun } from "react-icons/fa";
import { Upload } from "lucide-react";
// import defaultUser from "../../assets/img/user-default.jpg";

function Header({ isSidebarExpanded, toggleSidebar, theme, toggleTheme }) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { showAlert } = useAlert();

  const [showModal, setShowModal] = useState(false);
  const [showSettingModal, setShowSettingModal] = useState(false);
  const [showZoneLogoModal, setShowZoneLogoModal] = useState(false);
  const [showChangePassModal, setShowChangePassModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [viewAllModal, setViewAllModal] = useState(false);
  const [showProfilePictureModal, setShowProfilePictureModal] = useState(false);
  const [showDocumentDownloadModal, setShowDocumentDownloadModal] =
    useState(false);
  const [isKycModalOpen, setIsKycModalOpen] = useState(false);
  const [active, setActive] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const { user } = useSelector((state) => state.jwtAuthreducer);
  const auth = useSelector((state) => state.jwtAuthreducer);
  const [notifications, setNotifications] = useState([]);
  const login = useSelector((state) => state.jwtAuthreducer);
  const [zoneId] = useState(
    localStorage.getItem("zone_id") || login?.user?.zone_id
  );
  const [zoneName, setZoneName] = useState("");
  const {
    currentPage,
    itemPerPage,
    disablePrev,
    disableNext,
    disableFirst,
    disableLast,
    totalPages,
    updateCurrentPage,
    updateTotalRecords,
  } = usePagination();

  const { data, isLoading, refetch } = useQuery(
    ["fetch-all-notification", currentPage],
    () =>
      getEmployeesNotification({ employee_code: auth?.user?.employee_code_id }),
    // () => getEmployeesNotification(),
    {
      keepPreviousData: false,
      staleTime: STALE_TIME,
      // refetchInterval: 5000,
      onSuccess: (res) => {
        if (active) {
          setViewAllModal(true);
        }
        setTotalCount(res?.data?.additional_data?.total_count);
        updateTotalRecords(res.data?.additional_data?.total_count);
        if (res?.data?.data) {
          const notifications = res.data.data.map((x, index) => ({
            ...x,
            _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
          }));
          dispatch({
            type: "ADD_NOTIFICATION",
            payload: notifications,
          });
        }
      },
      select: (res) => {
        const response = res?.data?.data;
        if (response && response?.length) {
          res.data.data = response?.map((x, index) => ({
            ...x,
            _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
          }));
        }
        return res;
      },
    }
  );

  const { data: profilePictureData } = useQuery(
    ["fetch-profile-picture", auth?.user?.employee_code_id],
    () =>
      getEmployeeProfilePicture({
        employee_code_id: auth?.user?.employee_code_id,
      }),
    {
      staleTime: STALE_TIME,
      enabled: Number(auth?.user?.employee_code_id) > 0,
    }
  );

  const { data: zoneData } = useQuery(
    ["zones"],
    () => fetchZonesDD({ ...login }),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  const onSuccess = () => {
    showAlert("update notification", "success");
    handleHideChangeViewAllModal();
  };

  const onError = () => {
    showAlert("Something went wrong!", "danger");
    handleHideChangeViewAllModal();
  };

  const { mutate: updateEmployeesNotificationMutate } = useMutation({
    mutationFn: updateEmployeesNotification,
    onSuccess,
    onError,
  });

  const readNotification = useCallback(
    (row) => {
      updateEmployeesNotificationMutate({
        id: row?.id,
        read: true,
      });
    },
    [updateEmployeesNotificationMutate]
  );

  useEffect(() => {
    if (zoneData && zoneId) {
      const matchedZone = zoneData?.data?.zone_data?.find(
        (zone) => zone?.zone_id == zoneId
      );
      if (matchedZone) {
        setZoneName(matchedZone?.zone_name);
        if (matchedZone?.zone_name) {
          localStorage.setItem("zone_name", matchedZone.zone_name);
        }
      }
    }
  }, [zoneData, zoneId]);

  useEffect(() => {
    if (data?.data?.data) {
      setNotifications(data.data.data);
    }
  }, [data]);

  useEffect(() => {
    refetch();
  }, [auth?.user?.employee_code_id, currentPage, refetch]);

  const onSuccessForLogOut = () => {
    showAlert("Employee logout marked successfully!", "success");
  };

  const onErrorForLogOut = () => {
    showAlert("Failed to mark employee logout!", "danger");
  };

  const { mutate: createEmployeeMarkLogOutMutate } = useMutation({
    mutationFn: createEmployeeMarkLogOut,
    onSuccess: onSuccessForLogOut,
    onError: onErrorForLogOut,
  });

  const reset = () => {
    const currentDate = new Date().toISOString().split("T")[0];

    const now = new Date();
    const options = { timeZone: "Asia/Kolkata", hour12: false };
    const currentTime = now.toLocaleTimeString("en-GB", options);

    const logoutPayload = {
      employee_code_id: auth?.user?.employee_code_id,
      generated_date: currentDate,
      logout_time: currentTime,
      logout_records_updated_status: "EMPLOYEE",
      company_id: companyLocalStorageId(),
    };

    createEmployeeMarkLogOutMutate(logoutPayload);

    setTimeout(() => {
      dispatch(logout());
    }, 2000);
  };

  const handleMyAccountClick = () => {
    setShowModal(true);
  };

  const handleChangePassClick = () => {
    setShowChangePassModal(true);
  };

  const handleSettingClick = () => {
    setShowSettingModal(true);
  };

  const handleHideSettingModal = () => {
    setShowSettingModal(false);
  };

  const handleHideChangePassModal = () => {
    setShowChangePassModal(false);
  };

  const handleHideModal = () => {
    setShowModal(false);
  };

  const handleChangeImageClick = () => {
    setShowImageModal(true);
  };

  const handleProfilePictureClick = () => {
    setShowProfilePictureModal(true);
  };

  const handleHideProfilePictureModal = (uploaded = false) => {
    setShowProfilePictureModal(false);
    if (uploaded) {
      // Invalidate the cached profile picture so the header avatar refetches immediately
      queryClient.invalidateQueries(["fetch-profile-picture"]);
    }
  };

  const handleDocumentDownloadClick = () => {
    setShowDocumentDownloadModal(true);
  };

  const handleHideDocumentDownloadModal = () => {
    setShowDocumentDownloadModal(false);
  };

  const handleHideChangeImageModal = () => {
    setShowImageModal(false);
  };

  const handleChangeViewAllClick = () => {
    setActive(true);
    setViewAllModal(true);
  };

  const handleHideChangeViewAllModal = () => {
    setActive(false);
    updateCurrentPage(1);
    refetch();
    setViewAllModal(false);
  };

  const handleKycVerification = () => {
    setShowDocumentDownloadModal(false);
    setIsKycModalOpen(true);
  };

  const handleHideKYCModal = () => {
    setIsKycModalOpen(false);
    setShowDocumentDownloadModal(true);
  };

  const loadNextPage = useCallback(() => {
    setViewAllModal(false);
    updateCurrentPage(currentPage + 1);
  }, [currentPage, updateCurrentPage]);

  const loadPreviousPage = useCallback(() => {
    setViewAllModal(false);
    updateCurrentPage(currentPage - 1);
  }, [currentPage, updateCurrentPage]);

  const loadFirstPage = useCallback(() => {
    setViewAllModal(false);
    if (currentPage !== 1) {
      updateCurrentPage(1);
    }
  }, [currentPage, updateCurrentPage]);

  const loadLastPage = useCallback(() => {
    setViewAllModal(false);
    if (currentPage !== totalPages) {
      updateCurrentPage(totalPages);
    }
  }, [currentPage, totalPages, updateCurrentPage]);

  const convertTimestampToDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    if (isNaN(date.getTime())) {
      return null;
    }
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const isFranchiseEmployee = Number(
    localStorage.getItem("is_franchise_employee")
  );

  // const toggleSidebar = () => {
  //   setIsSidebarExpanded((prev) => !prev);
  // };

  const visibleNotifications = useMemo(() => {
    return notifications?.slice(0, 4);
  }, [notifications]);

  const columns = useMemo(() => {
    return NOTIFICATION_COLUMNS_DATA({
      readNotification,
    });
  }, [readNotification]);

  useEffect(() => {
    refetch();
  }, [auth?.user?.employee_code_id]);

  const [isSuperFranchise] = useState(() =>
    Number(localStorage.getItem("is_super_franchise"))
  );
  const [isSubFranchise] = useState(() =>
    Number(localStorage.getItem("sub_franchise"))
  );

  const isPDF = (base64String) => {
    return base64String && base64String.startsWith("JVBERi0");
  };

  const roles = login?.user?.employee_roles || [];
  const canManageZoneLogo =
    Number(auth?.user?.employee_code_id) === 1 ||
    roles.some((role) =>
      ["CEO", "SUPER_ADMIN", "SUPER ADMIN"].includes(role?.role_name),
    );
  const IS_PATIENT_REPORT_FORMAT_CHANGE = roles.some(
    (data) => data?.role_name === "PATIENT REPORT FORMAT CHANGE"
  );

  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setQuery(e.target.value);
  };

  const handleNavigate = () => {
    if (query.trim() !== "" && IS_PATIENT_REPORT_FORMAT_CHANGE) {
      navigate(`/patient-report?search=${query}`);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleNavigate();
    }
  };

  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {!isMobileView && (
        <header className={`${!isSidebarExpanded ? "header" : "headerClose"}`}>
          <div className="left d-flex mr-3">
            {isSidebarExpanded ? (
              <div id="nav-icon-mobile" onClick={toggleSidebar}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            ) : (
              <div id="nav-icon-mobile-close" onClick={toggleSidebar}>
                <span></span>
                <span></span>
              </div>
            )}

            <div className="logo d-md-none">
              <a href="#">
                <DynamicZoneLogo
                  fallbackSrc={DEFAULT_APP_LOGO_SRC}
                  alt=""
                  title="Logo"
                />
              </a>
            </div>
          </div>

          <div className="right">
            <div className="searchWrap">
              <div className="searchFieldWrap d-none d-md-flex">
                <div className="input-group d-none d-md-flex">
                  <input
                    type="text"
                    placeholder="Search something"
                    className="form-control grey-input"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    value={query}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onBlur={handleNavigate}
                  />
                </div>
                <button className="searchButton d-none d-md-flex">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 27 26"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12.1334 0C5.76746 0 0.607666 5.15979 0.607666 11.5258C0.607666 17.8918 5.76746 23.0515 12.1334 23.0515C15.0819 23.0515 17.7623 21.9124 19.7726 20.1031L25.6695 26L26.6077 25.0619L20.7108 19.1649C22.52 17.1546 23.6592 14.4742 23.6592 11.5258C23.6592 5.15979 18.4994 0 12.1334 0ZM1.94787 11.5258C1.94787 5.89691 6.50457 1.34021 12.1334 1.34021C17.7623 1.34021 22.319 5.89691 22.319 11.5258C22.319 17.1546 17.7623 21.7113 12.1334 21.7113C6.50457 21.7113 1.94787 17.1546 1.94787 11.5258Z" />
                  </svg>
                </button>

                <button className="searchButton d-flex d-md-none">
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 27 26"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12.1334 0C5.76746 0 0.607666 5.15979 0.607666 11.5258C0.607666 17.8918 5.76746 23.0515 12.1334 23.0515C15.0819 23.0515 17.7623 21.9124 19.7726 20.1031L25.6695 26L26.6077 25.0619L20.7108 19.1649C22.52 17.1546 23.6592 14.4742 23.6592 11.5258C23.6592 5.15979 18.4994 0 12.1334 0ZM1.94787 11.5258C1.94787 5.89691 6.50457 1.34021 12.1334 1.34021C17.7623 1.34021 22.319 5.89691 22.319 11.5258C22.319 17.1546 17.7623 21.7113 12.1334 21.7113C6.50457 21.7113 1.94787 17.1546 1.94787 11.5258Z" />
                  </svg>
                </button>
              </div>
              {zoneName != "" ? (
                <div className="ms-2 d-flex align-items-center gap-2">
                  <h4 className="mt-1 fw-bold" style={{ color: "rgb(15 114 118)" }}>
                    {zoneName}
                  </h4>
                  {canManageZoneLogo && (
                    <button
                      type="button"
                      className="btn btn-sm btn-light"
                      onClick={() => setShowZoneLogoModal(true)}
                      title="Upload zone logo"
                      aria-label="Upload zone logo"
                    >
                      <Upload size={15} />
                    </button>
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>

            <div className="userWrap">
              <button
                type="button"
                className="theme-toggle"
                onClick={toggleTheme}
                aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
                title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
              >
                {theme === "dark" ? <FaSun aria-hidden="true" /> : <FaMoon aria-hidden="true" />}
              </button>
              <div className="dropdown notifications">
                <a
                  className="dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img src="../assets/img/bell-icon.png" alt="" title="Logo" />
                  <span className="count">{totalCount}</span>
                </a>

                <ul className="dropdown-menu">
                  {visibleNotifications?.length > 0 ? (
                    visibleNotifications.map((item, index) => (
                      <li key={index}>
                        <a className="dropdown-item" href="#">
                          <h3 className="fw-bold">{item?.title}</h3>
                          <p className="mb-0">{stripHtml(item?.message)}</p>
                        </a>
                      </li>
                    ))
                  ) : (
                    <li>
                      <a className="dropdown-item" href="#">
                        <p className="mb-0">No Notifications</p>
                      </a>
                    </li>
                  )}
                  {data?.data?.data?.length > 5 && (
                    <li>
                      <button
                        className="dropdown-item text-center view-all-btn"
                        onClick={() => handleChangeViewAllClick()}
                      >
                        {"View All"}
                      </button>
                    </li>
                  )}
                </ul>
              </div>
              <div className="user">
                <a
                  className="dropdown-toggle flex-center"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {profilePictureData?.data ? (
                    isPDF(profilePictureData.data) ? (
                      <object
                        data={`data:application/pdf;base64,${profilePictureData.data}`}
                        type="application/pdf"
                        width="38"
                        height="38"
                        style={{
                          borderRadius: "50%",
                          width: "38px",
                          height: "38px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <img
                          src="../assets/img/user-default.jpg"
                          width="38"
                          alt="User"
                          title="User"
                          style={{
                            borderRadius: "50%",
                            width: "38px",
                            height: "38px",
                          }}
                        />
                      </object>
                    ) : (
                      <img
                        src={`data:image/jpeg;base64,${profilePictureData.data}`}
                        width="38"
                        alt="User"
                        title="User"
                        style={{
                          borderRadius: "50%",
                          width: "38px",
                          height: "38px",
                        }}
                      />
                    )
                  ) : (
                    <img
                      src="../assets/img/user-default.jpg"
                      width="38"
                      alt="User"
                      title="User"
                      style={{
                        borderRadius: "50%",
                        width: "38px",
                        height: "38px",
                      }}
                    />
                  )}

                  <span className="d-none d-md-flex">
                    {user?.employee_name || "John Deo"}
                  </span>
                  <span className="angle angleDown"></span>
                </a>

                <ul className="dropdown-menu">
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={handleMyAccountClick}
                    >
                      My Account
                    </a>
                  </li>
                  {isSuperFranchise !== 1 &&
                    isFranchiseEmployee !== 1 &&
                    isSubFranchise !== 1 && (
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={handleChangeImageClick}
                        >
                          Change Image PDF
                        </a>
                      </li>
                    )}
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={handleChangePassClick}
                    >
                      Change Password
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={handleProfilePictureClick}
                    >
                      Profile Picture
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={handleDocumentDownloadClick}
                    >
                      Document & Download
                    </a>
                  </li>
                  {isFranchiseEmployee === 0 && (
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleSettingClick}
                      >
                        Settings
                      </a>
                    </li>
                  )}
                  <li>
                    <a
                      href="#"
                      className="dropdown-item"
                      onClick={() => reset()}
                    >
                      Logout
                    </a>
                    {/* <Link to="/" className="dropdown-item" onClick={() => reset()}>
                                        Logout
                                    </Link> */}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </header>
      )}

      {isMobileView && (
        <header
          className={`${!isSidebarExpanded ? "headerMobile" : "headerClose"}`}
        >
          <div className="d-flex justify-content-between w-100 align-items-center">
            <div className="left d-flex">
              {isSidebarExpanded ? (
                <div id="nav-icon-mobile" onClick={toggleSidebar}>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              ) : (
                <div id="nav-icon-mobile-close" onClick={toggleSidebar}>
                  <span></span>
                  <span></span>
                </div>
              )}

              <div className="logo d-md-none">
                <a href="#">
                  <DynamicZoneLogo
                    fallbackSrc={DEFAULT_APP_LOGO_SRC}
                    alt=""
                    title="Logo"
                  />
                </a>
              </div>
            </div>

            <div className="right">
              <div className="searchWrap">
                <div className="searchFieldWrap d-none d-md-flex">
                  <div className="input-group d-none d-md-flex">
                    <input
                      type="text"
                      placeholder="Search something"
                      className="form-control grey-input"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-default"
                      value={query}
                      onChange={handleChange}
                      onKeyDown={handleKeyDown}
                      onBlur={handleNavigate}
                    />
                  </div>
                  <button className="searchButton d-none d-md-flex">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 27 26"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12.1334 0C5.76746 0 0.607666 5.15979 0.607666 11.5258C0.607666 17.8918 5.76746 23.0515 12.1334 23.0515C15.0819 23.0515 17.7623 21.9124 19.7726 20.1031L25.6695 26L26.6077 25.0619L20.7108 19.1649C22.52 17.1546 23.6592 14.4742 23.6592 11.5258C23.6592 5.15979 18.4994 0 12.1334 0ZM1.94787 11.5258C1.94787 5.89691 6.50457 1.34021 12.1334 1.34021C17.7623 1.34021 22.319 5.89691 22.319 11.5258C22.319 17.1546 17.7623 21.7113 12.1334 21.7113C6.50457 21.7113 1.94787 17.1546 1.94787 11.5258Z" />
                    </svg>
                  </button>

                  <button className="searchButton d-flex d-md-none">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 27 26"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12.1334 0C5.76746 0 0.607666 5.15979 0.607666 11.5258C0.607666 17.8918 5.76746 23.0515 12.1334 23.0515C15.0819 23.0515 17.7623 21.9124 19.7726 20.1031L25.6695 26L26.6077 25.0619L20.7108 19.1649C22.52 17.1546 23.6592 14.4742 23.6592 11.5258C23.6592 5.15979 18.4994 0 12.1334 0ZM1.94787 11.5258C1.94787 5.89691 6.50457 1.34021 12.1334 1.34021C17.7623 1.34021 22.319 5.89691 22.319 11.5258C22.319 17.1546 17.7623 21.7113 12.1334 21.7113C6.50457 21.7113 1.94787 17.1546 1.94787 11.5258Z" />
                    </svg>
                  </button>
                </div>
                {zoneName != "" ? (
                  <div className="ms-2 d-flex align-items-center gap-2">
                    <h4 className="mt-1 fw-bold" style={{ color: "#0d6efd" }}>
                      {zoneName}
                    </h4>
                    {canManageZoneLogo && (
                      <button
                        type="button"
                        className="btn btn-sm btn-light"
                        onClick={() => setShowZoneLogoModal(true)}
                        title="Upload zone logo"
                        aria-label="Upload zone logo"
                      >
                        <Upload size={15} />
                      </button>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className="userWrap">
                <button
                  type="button"
                  className="theme-toggle"
                  onClick={toggleTheme}
                  aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
                  title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
                >
                  {theme === "dark" ? <FaSun aria-hidden="true" /> : <FaMoon aria-hidden="true" />}
                </button>
                <div className="dropdown notifications">
                  <a
                    className="dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src="../assets/img/bell-icon.png"
                      alt=""
                      title="Logo"
                    />
                    <span className="count">{totalCount}</span>
                  </a>

                  <ul className="dropdown-menu">
                    {visibleNotifications?.length > 0 ? (
                      visibleNotifications.map((item, index) => (
                        <li key={index}>
                          <a className="dropdown-item" href="#">
                            <h3 className="fw-bold">{item?.title}</h3>
                            <p className="mb-0">{stripHtml(item?.message)}</p>
                          </a>
                        </li>
                      ))
                    ) : (
                      <li>
                        <a className="dropdown-item" href="#">
                          <p className="mb-0">No Notifications</p>
                        </a>
                      </li>
                    )}
                    {data?.data?.data?.length > 5 && (
                      <li>
                        <button
                          className="dropdown-item text-center view-all-btn"
                          onClick={() => handleChangeViewAllClick()}
                        >
                          {"View All"}
                        </button>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="user">
                  <a
                    className="dropdown-toggle flex-center"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {profilePictureData?.data ? (
                      isPDF(profilePictureData.data) ? (
                        <object
                          data={`data:application/pdf;base64,${profilePictureData.data}`}
                          type="application/pdf"
                          width="38"
                          height="38"
                          style={{
                            borderRadius: "50%",
                            width: "38px",
                            height: "38px",
                            border: "1px solid #ddd",
                          }}
                        >
                          <img
                            src="../assets/img/user-default.jpg"
                            width="38"
                            alt="User"
                            title="User"
                            style={{
                              borderRadius: "50%",
                              width: "38px",
                              height: "38px",
                            }}
                          />
                        </object>
                      ) : (
                        <img
                          src={`data:image/jpeg;base64,${profilePictureData.data}`}
                          width="38"
                          alt="User"
                          title="User"
                          style={{
                            borderRadius: "50%",
                            width: "38px",
                            height: "38px",
                          }}
                        />
                      )
                    ) : (
                      <img
                        src="../assets/img/user-default.jpg"
                        width="38"
                        alt="User"
                        title="User"
                        style={{
                          borderRadius: "50%",
                          width: "38px",
                          height: "38px",
                        }}
                      />
                    )}

                    <span className="d-none d-md-flex">
                      {user?.employee_name || "John Deo"}
                    </span>
                    <span className="angle angleDown"></span>
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleMyAccountClick}
                      >
                        My Account
                      </a>
                    </li>
                    {isSuperFranchise !== 1 &&
                      isFranchiseEmployee !== 1 &&
                      isSubFranchise !== 1 && (
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={handleChangeImageClick}
                          >
                            Change Image PDF
                          </a>
                        </li>
                      )}
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleChangePassClick}
                      >
                        Change Password
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleProfilePictureClick}
                      >
                        Profile Picture
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleDocumentDownloadClick}
                      >
                        Document & Download
                      </a>
                    </li>
                    {isFranchiseEmployee === 0 && (
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={handleSettingClick}
                        >
                          Settings
                        </a>
                      </li>
                    )}
                    <li>
                      <a
                        href="#"
                        className="dropdown-item"
                        onClick={() => reset()}
                      >
                        Logout
                      </a>
                      {/* <Link to="/" className="dropdown-item" onClick={() => reset()}>
                                        Logout
                                    </Link> */}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="searchFieldWrap mb-2 d-flex d-md-none">
            <div className="input-group d-flex d-md-none">
              <input
                type="text"
                placeholder="Search something"
                className="form-control grey-input"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
                value={query}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onBlur={handleNavigate}
              />
            </div>
            <button className="searchButton d-flex d-md-none">
              <svg
                width="26"
                height="26"
                viewBox="0 0 27 26"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12.1334 0C5.76746 0 0.607666 5.15979 0.607666 11.5258C0.607666 17.8918 5.76746 23.0515 12.1334 23.0515C15.0819 23.0515 17.7623 21.9124 19.7726 20.1031L25.6695 26L26.6077 25.0619L20.7108 19.1649C22.52 17.1546 23.6592 14.4742 23.6592 11.5258C23.6592 5.15979 18.4994 0 12.1334 0ZM1.94787 11.5258C1.94787 5.89691 6.50457 1.34021 12.1334 1.34021C17.7623 1.34021 22.319 5.89691 22.319 11.5258C22.319 17.1546 17.7623 21.7113 12.1334 21.7113C6.50457 21.7113 1.94787 17.1546 1.94787 11.5258Z" />
              </svg>
            </button>
          </div>
        </header>
      )}
      <Modal
        show={showModal}
        onHide={handleHideModal}
        modalName="myAccountModal"
        title="My Account Details"
        body={
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6">
                <div className="info-item">
                  <span className="info-label">Name:</span>
                  <span className="info-value">{user?.employee_name}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Username:</span>
                  <span className="info-value">{user?.username}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Email:</span>
                  <span className="info-value">{user?.email}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Mobile:</span>
                  <span className="info-value">{user?.mobile}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Branch:</span>
                  <span className="info-value">{user?.branch_name}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Designation:</span>
                  <span className="info-value">{user?.designation}</span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="info-item">
                  <span className="info-label">Generated:</span>
                  <span className="info-value">
                    {convertTimestampToDate(user?.generated)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Joining Date:</span>
                  <span className="info-value">{user?.joining_date}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Department:</span>
                  <span className="info-value">{user?.department}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Zone:</span>
                  <span className="info-value">{user?.zone_name}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Is Active:</span>
                  <span className="info-value">
                    {user?.is_active ? "Yes" : "No"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Is Working:</span>
                  <span className="info-value">
                    {user?.is_working ? "Yes" : "No"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
        footer={
          <button
            type="button"
            className="btn btn-primary "
            onClick={handleHideModal}
          >
            Close
          </button>
        }
        type="modal-lg"
      />
      <Modal
        show={showChangePassModal}
        onHide={handleHideChangePassModal}
        modalName="changePassModal"
        title="Reset Password"
        body={<ResetPassword onClose={handleHideChangePassModal} />}
        type="modal-lg"
      />
      <Modal
        show={showSettingModal}
        onHide={handleHideSettingModal}
        modalName="settingModal"
        title="Settings"
        body={
          <div style={{ height: "120px" }}>
            <SettingZoneDropDown />
          </div>
        }
        type="modal-lg "
      />
      <Modal
        show={showZoneLogoModal}
        onHide={() => setShowZoneLogoModal(false)}
        modalName="zoneLogoUploadModal"
        title="Upload Zone Logo"
        body={
          showZoneLogoModal ? (
            <ZoneLogoUpload
              zoneId={zoneId || auth?.user?.zone_id}
              onClose={() => setShowZoneLogoModal(false)}
            />
          ) : null
        }
        type="modal-md"
      />
      <Modal
        type="modal-lg"
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        modalName={MODALS.ADD_FOOTER_HEADER_IMAGE_MODAL}
        title={"Upload File"}
        body={<UploadImages onClose={handleHideChangeImageModal} />}
      />

      <Modal
        type="modal-lg"
        show={showProfilePictureModal}
        onHide={handleHideProfilePictureModal}
        modalName={MODALS.ADD_FOOTER_HEADER_IMAGE_MODAL}
        title={"Upload Profile Picture"}
        body={<ProfilePicture onClose={handleHideProfilePictureModal} />}
      />

      <Modal
        type="modal-xl"
        show={showDocumentDownloadModal}
        onHide={() => setShowDocumentDownloadModal(false)}
        modalName={MODALS.ADD_FOOTER_HEADER_IMAGE_MODAL}
        title={"Document Download"}
        body={
          <DocumentsDownload
            onClose={handleHideDocumentDownloadModal}
            onKycVerification={handleKycVerification}
          />
        }
      />
      <Modal
        type="modal-xl"
        show={isKycModalOpen}
        onHide={handleHideKYCModal}
        modalName={MODALS.ADD_FOOTER_HEADER_IMAGE_MODAL}
        title={"KYC Document Upload"}
        body={
          <UploadDocument
            onClose={handleHideKYCModal}
            setIsKycModalOpen={setIsKycModalOpen}
          />
        }
      />
      <Modal
        type="modal-xl"
        show={viewAllModal}
        onHide={() => handleHideChangeViewAllModal()}
        modalName={MODALS.NOTIFICATION}
        title={"Notification"}
        body={
          <Table
            data={data?.data?.data || []}
            isLoading={isLoading}
            tableColumns={columns}
            currentPage={currentPage}
            totalPages={totalPages}
            itemPerPage={itemPerPage}
            disablePrev={disablePrev}
            disableNext={disableNext}
            disableFirst={disableFirst}
            disableLast={disableLast}
            loadFirstPage={loadFirstPage}
            loadLastPage={loadLastPage}
            totalRecords={5}
            loadNextPage={loadNextPage}
            loadPreviousPage={loadPreviousPage}
          />
        }
      />
    </>
  );
}
export default Header;
